var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDevelopment())?_c('div',[_vm._m(0),_c('div',{staticClass:"mt-2",domProps:{"innerHTML":_vm._s(_vm.field.etiqueta)}})]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"v-label"},[_vm._v(" »@@variable_TEST« "),_c('span',[_vm._v("(Esta variable únicamente aparecerá en test)")])])
}]

export { render, staticRenderFns }